{
  "round_statistics": "Round Statistics",
  "no_stats_tracked": "No statistics tracked for this round",
  "no_stats_available": "No statistics available",
  "fairway_accuracy": "Fairway Accuracy",
  "total_fairways_attempted": "Total Fairways Attempted",
  "fairway_hit_percentage": "Fairway Hit %",
  "center": "Center",
  "left": "Left",
  "right": "Right",
  "short": "Short",
  "long": "Long",
  "green_accuracy": "Green Accuracy",
  "total_greens_attempted": "Total Greens Attempted",
  "greens_in_regulation": "Greens in Regulation (GIR)",
  "gir_percentage": "GIR %",
  "on_green": "On Green",
  "putting_performance": "Putting",
  "total_putts": "Total Putts",
  "avg_per_hole": "Avg per Hole",
  "avg_per_gir": "Avg per GIR",
  "first_putt_distribution": "First Putt Distribution",
  "total_sinked": "Total Putts Made",
  "short_game": "Short Game",
  "total_chips": "Total Chips",
  "up_and_downs": "Up and Downs",
  "up_and_down_percentage": "Up and Down %",
  "bunker_play": "Bunker Play",
  "total_bunker_shots": "Total Bunker Shots",
  "sand_saves": "Sand Saves",
  "sand_save_percentage": "Sand Save %",
  "penalties": "Penalties",
  "total_penalties": "Total Penalties",
  "birdies": "Birdies",
  "three_putts": "3+ Putts",
  "fairway": "Fairway",
  "gir_short": "GIR",
  "score_distribution": "Score Distribution",
  "eagle_or_better": "Eagle or Better",
  "birdie": "Birdie",
  "par": "Par",
  "bogey": "Bogey",
  "double_bogey_or_worse": "Double Bogey or Worse",
  "total_scored_holes": "Total Scored Holes",
  "dashboard": {
    "title": "My Statistics",
    "year": "Year",
    "season": "Season {{year}}",
    "course": "Course",
    "allYears": "All Years",
    "allCourses": "All Courses",
    "updating": "Updating...",
    "loadError": "Failed to load statistics",
    "overview": {
      "title": "Overview",
      "avgScore": "Avg Score",
      "fir": "FIR",
      "gir": "GIR",
      "avgPutts": "Avg Putts"
    },
    "tabs": {
      "results": "Results",
      "accuracy": "FIR/GIR",
      "putting": "Putts",
      "other": "Other"
    },
    "accuracyStats": {
      "fairway": "Fairways in Regulation",
      "fairwayLeft": "Left",
      "fairwayRight": "Right",
      "gir": "Greens in Regulation",
      "greenLeft": "Left",
      "greenRight": "Right",
      "greenShort": "Short",
      "greenLong": "Long"
    },
    "totalRounds": "Rounds",
    "totalHoles": "Holes",
    "avgScore": "Average",
    "avgToPar": "Avg to Par",
    "scoring": "Scoring",
    "accuracy": "Fairway Accuracy",
    "putting": "Putting",
    "other": "Other Statistics",
    "metric": "Metric",
    "you": "You",
    "friends": "Friends",
    "global": "All",
    "bestScore": "Best Scratch Score",
    "worstScore": "Worst Score",
    "eagles": "Eagles",
    "birdies": "Birdies",
    "pars": "Pars",
    "bogeys": "Bogeys",
    "doubleBogeys": "Double Bogeys",
    "triplePlus": "+3 or Worse",
    "fairwayHit": "Fairway %",
    "gir": "GIR %",
    "upAndDown": "Up & Down %",
    "sandSave": "Sand Save %",
    "avgPuttsPerHole": "Avg Putts/Hole",
    "avgPuttsPerRound": "Avg Putts/Round",
    "totalPutts": "Total Putts",
    "totalChips": "Chips",
    "totalBunkerShots": "Bunker Shots",
    "avgPenaltiesPerRound": "Avg Penalties/Round",
    "totalPenalties": "Total Penalties",
    "fullRoundsOnly": "Full Rounds Only",
    "scratchScoring": "Scratch Scoring",
    "bestRound": "Best Round",
    "avgRound": "Round Average",
    "best9Holes": "Best 9-Hole Round",
    "avg9Holes": "9-Hole Round Average",
    "netScoring": "Net Scoring",
    "rounds": "rounds",
    "holeStats": "Hole Results",
    "avgChipsPerRound": "Avg. chips/round",
    "avgBunkerShotsPerRound": "Avg. bunker shots/round"
  },
  "sunk_putt_distribution": "Sunk putt distribution",
  "holes_count": "{{count}} holes",
  "one_putts": "1 Putt",
  "chip_proximity": "Chip proximity (1st putt)",
  "approach_proximity": "Approach proximity (1st putt)",
  "proximity_holed": "Holed"
}
